import { render, staticRenderFns } from "./domain.vue?vue&type=template&id=fc918a0a&scoped=true&"
import script from "./domain.vue?vue&type=script&lang=js&"
export * from "./domain.vue?vue&type=script&lang=js&"
import style0 from "./domain.vue?vue&type=style&index=0&id=fc918a0a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc918a0a",
  null
  
)

component.options.__file = "domain.vue"
export default component.exports